import React from "react";
import { Search, X } from "lucide-react";

/**
 * Shared search bar used across all admin table pages.
 *
 * Props:
 *   value       {string}   – controlled value
 *   onChange    {fn}       – called with new string on every keystroke
 *   onCommit    {fn}       – called when Enter is pressed (optional)
 *   onClear     {fn}       – called when X is clicked (optional, falls back to onChange(""))
 *   placeholder {string}   – input placeholder text
 *   className   {string}   – extra wrapper classes
 */
const SearchBar = ({ value, onChange, onCommit, onClear, placeholder = "Search…", className = "" }) => (
  <div className={`relative flex-1 max-w-md ${className}`}>
    <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-brand-light pointer-events-none" />
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={(e) => { if (e.key === "Enter" && onCommit) onCommit(value); }}
      className="w-full pl-9 pr-8 py-2 border border-surface-border rounded-lg text-sm text-brand-text placeholder:text-brand-light bg-white focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition"
    />
    {value && (
      <button
        onClick={() => { onChange(""); if (onClear) onClear(); else if (onCommit) onCommit(""); }}
        className="absolute right-2.5 top-1/2 -translate-y-1/2 text-brand-light hover:text-brand-text transition-colors"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    )}
  </div>
);

export default SearchBar;
